import { useCallback, useMemo } from 'react';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../utils/types';
import { exportTableToCsv } from '../../MultiGridTable';
import { useChartContext } from '../ChartContext';
import getChartDataTableCsvData from './getChartDataTableCsvData';
import useCacheDataTableLlmRawDataEffect from '../hooks/llmCacheRawData/useCacheDataTableLlmRawDataEffect';

export default (analysisId: string) => {
  const {
    chartData,
    metadata: { query, comparisonInfo, display },
    displayedMeasures,
    settings: { chartSettings },
  } = useChartContext();
  const { tableSettings } = chartSettings;
  // only enabled for data table queries
  assertCondition(chartData?.queryType === QueryType.DataTable);
  assertCondition(query?.__typename === 'DataTableQuery');
  const { headers, data } = useMemo(
    () =>
      getChartDataTableCsvData({
        chartData,
        query,
        displayedMeasures,
        comparisonConfig: comparisonInfo?.comparisonConfig ?? null,
        tableSettings,
      }),
    [chartData, query, tableSettings, displayedMeasures, comparisonInfo],
  );

  const executeCsvExport = useCallback(() => {
    // execute csv download
    exportTableToCsv({
      display: `${display}-${analysisId}`,
      headers,
      data,
    });
  }, [display, analysisId, headers, data]);

  // XXX Also cache the CSV data as the Llm "context" raw data, to be included in a LLM prompt
  useCacheDataTableLlmRawDataEffect({
    analysisId,
    headers,
    data,
  });

  return { executeCsvExport };
};
